import * as yup from "yup";

export const JornadaSchema = yup.object().shape({
  diaSemana: yup.string().required("errors.jornadaLaboral.diaSemana.required"),
  inicio: yup
    .string()
    .typeError("errors.jornadaLaboral.inicio.type")
    .transform((value, originalValue) => {
      if (!value) return value;
      const [hora, minutos] = value.split(":");
      return new Date(1973, 1, 1, hora, minutos);
    })
    .test("lt", "errors.jornadaLaboral.inicio.test", (value, context) => {
      const {
        parent: { termino },
      } = context;
      return value < termino;
    })
    .transform((value, originalValue) => {
      return originalValue;
    })
    .required("errors.jornadaLaboral.inicio.required")
    .default(null),
  termino: yup
    .string()
    .typeError("errors.jornadaLaboral.termino.type")
    .transform((value, originalValue) => {
      if (!value) return value;
      const [hora, minutos] = value.split(":");
      return new Date(1973, 1, 1, hora, minutos);
    })
    .test("gt", "errors.jornadaLaboral.termino.test", (value, context) => {
      const {
        parent: { inicio },
      } = context;
      return value > inicio;
    })
    .transform((value, originalValue) => {
      return originalValue;
    })
    .required("errors.jornadaLaboral.termino.required")
    .default(null),
  turnos: yup
    .number()
    .integer()
    .typeError("errors.jornadaLaboral.turnos.type")
    .min(1, "errors.jornadaLaboral.turnos.min")
    .max(4, "errors.jornadaLaboral.turnos.max")
    .required("errors.jornadaLaboral.turnos.required"),
});
